import { NotificationBell, NotificationBellItem } from "@redelair-sa/intiza-ui";
import { TranslationService } from "../../../../services/TranslationService";
import { formatAnnouncementDate } from "./announcementFormat";
import { useAnnouncementsStore } from "./announcementsStore";

/** Campanita de la topbar con los comunicados vigentes (GDC-5184). */
const AnnouncementsBell = () => {
  const { translate } = TranslationService;
  const items = useAnnouncementsStore((state) => state.items);
  const dismissedIds = useAnnouncementsStore((state) => state.dismissedIds);
  const openFromBell = useAnnouncementsStore((state) => state.openFromBell);

  const bellItems: NotificationBellItem[] = items
    .filter((item) => !dismissedIds.includes(item.announcementId))
    .map((item) => ({
      id: String(item.announcementId),
      title: item.shortTitle,
      description: item.summary ?? undefined,
      timestamp: formatAnnouncementDate(item.publishedAt),
      read: item.read
    }));

  // "{showRead}" se reemplaza por el nombre del switch en negrita.
  const [hintBefore, hintAfter = ""] =
    translate.AnnouncementsEmptyUnreadHint.split("{showRead}");
  const emptyUnread = (
    <>
      {translate.AnnouncementsEmptyUnread}
      <br />
      {hintBefore}
      <strong>{translate.AnnouncementsShowRead}</strong>
      {hintAfter}
    </>
  );

  return (
    <NotificationBell
      items={bellItems}
      onItemClick={(item) => openFromBell(Number(item.id))}
      labels={{
        title: translate.Announcements,
        showRead: translate.AnnouncementsShowRead,
        emptyUnread,
        empty: translate.AnnouncementsEmpty,
        unread: translate.AnnouncementUnread
      }}
    />
  );
};

export default AnnouncementsBell;
